<div class="modal-readonly-prompt">
  <kmd-modal id="read-only-prompt" modalSize="large" headline="Prompt Details">
    <app-form-prompt [prompt]="prompt!" [readOnly]="true"/>
  </kmd-modal>
</div>
